import { createFetched, Fetched } from '../../api/common/fetched';
import { ActivityBatch } from './models/activityBatch';
export interface ActivityState {
  activities: Fetched<ActivityBatch, string>;
}

export const initialState: ActivityState = {
  activities: createFetched(),
};
